import * as React from 'react';
import { ExtraInfoPanelProps, ExtraInfoPanelState } from './types';
import { ExtraInfoFieldName } from './constants';
import { ExtraInfoItem } from './extra-info-item';
import { fromWireFormat } from './map-extra-info';
import { extraInfoConfig } from './configuration';
import { RoleBasedAccessCustomStateProps, withRoleBasedAccess } from '../role-based-access';
import { createExtraInfoValues } from 'app/components/access-panel/extra-info/create-extra-info-values';
import { hasExtraInfoValues } from 'app/components/access-panel/extra-info/selectors';

type ExtraInfoPanelComponentProps = ExtraInfoPanelProps & RoleBasedAccessCustomStateProps<ExtraInfoPanelState>;

class ExtraInfoPanelComponent extends React.PureComponent<ExtraInfoPanelComponentProps> {

  public componentDidMount() {
    this.buildInitalState();
  }

  public componentDidUpdate(prevProps: ExtraInfoPanelComponentProps) {
    this.buildInitalState();

    const { customState, formValues, changeCustomState } = this.props;
    if (!customState || formValues === prevProps.formValues) {
      return;
    }

    const extraInfo = customState.extraInfo.map(info => {

      const formValue = formValues[ExtraInfoFieldName(info.id)];
      const prevFormValue = prevProps.formValues[ExtraInfoFieldName(info.id)];
      return formValue === prevFormValue
        ? info
        : {
          ...info,
          value: formValue
        };
    });

    changeCustomState({ extraInfo });
  }

  private buildInitalState = () => {

    const { customState, changeCustomState, initialValue, extraInfoCodes } = this.props;

    // Check if state does not exist and there is initial value
    if (customState || !initialValue || !extraInfoCodes) {
      return;
    }

    const state = {
      extraInfo: createExtraInfoValues(extraInfoCodes.values, initialValue)
        .map(fromWireFormat)
        .filter(item => item)
    };

    changeCustomState(state);
  }

  public render() {
    const { customState: { extraInfo = [] } = {}, formComponent: SimpleForm, translation,
      clearValidation, validation, readOnly, codeOptionsEndpoint, simpleForm, formOptions
    } = this.props;

    const hasValues = this.props.extraInfoCodes.values.length > 0 || hasExtraInfoValues(extraInfo);

    return <>
      {hasValues
        ? <div className="row expanders-in-equal-cols">
          {extraInfo
            .filter(i => extraInfoConfig[i.datatype])
            .map(value => <ExtraInfoItem
              key={value.id}
              data={value}
              readOnly={readOnly}
              formComponent={SimpleForm}
              translation={translation}
              validation={validation}
              clearValidation={clearValidation}
              codeOptionsEndpoint={codeOptionsEndpoint}
              simpleForm={simpleForm}
              formOptions={formOptions}
            />)}
        </div>
        : !!readOnly && <p className="no-content">{translation.no_additional_info_has_been_added}</p>}
    </>;
  }
}

export const ExtraInfoPanel = withRoleBasedAccess<ExtraInfoPanelProps, ExtraInfoPanelState>(ExtraInfoPanelComponent);
